<h1 mat-dialog-title>
  {{ this.title }}
  @if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  @if (svgIcon) {
    <mat-icon class="!h-8" [svgIcon]="svgIcon" [inline]="true" />
  }
</h1>

<mat-dialog-content class="w-[35rem] justify-self-center whitespace-pre-line pb-16 pt-12 text-center text-lg/none">
  {{ body }}
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="handleButtonClick()">{{ buttonText }}</button>
</mat-dialog-actions>
